import { InputValidator, DOMFactory } from "./interfaces";

export class InputValidatorController implements InputValidator {
    constructor(
        private domFactory: DOMFactory
    ) {}

    validate( input: HTMLInputElement ): void {
        const repeaterButton = this.domFactory.getButton();

        if (input.value.trim() !== '') {
            repeaterButton.disabled = false;
            input.classList.remove('invalid');
        }

        input.addEventListener('change', (e) => {
            const target = e.target as HTMLInputElement;
            const isValid = target.value.trim() !== '';

            if (isValid) {
                repeaterButton.disabled = false;
                input.classList.remove('invalid');
            } else {
                repeaterButton.disabled = true;
                input.classList.add('invalid');
            }
        });
    }   
}